import React from 'react';
import UtilityService from '../../services/UtillityServices/UtilityService';
import imgCard from '../../assets/img/orange-classroom.jpg';
import './HorizontalCourseCard.scss';
import { ROLES } from '../../model/roles';
import { TIPO_CORSO } from '../../model/tipoCorso';

const HorizontalCourseCard = ({course, userLoggedIn, selectedRole, onRemoveCourse, isCreateUserView}) => {
  const imgSrc = course?.corso?.immagine_corso || imgCard;

  // Funzione dedicata per renderizzare i dettagli finanziari
  const renderPaymentDetails = () => {
    // Mostra i dettagli solo se un Partner o Superpartner sta iscrivendo un corsista
    if ((userLoggedIn?.role !== ROLES.PARTNER && userLoggedIn?.role !== ROLES.SUPERPARTNER) || selectedRole !== "corsista") {
      return null;
    }

    const prezzoOriginale = parseFloat(course?.corso?.prezzo) || 0;
    const scontoApplicato = parseFloat(course?.sconto) || 0;
    const margineMassimo = parseFloat(course?.sconto_massimo_partner) || 0;

    // CASO 1: Pagamento con VOUCHER (a carico del partner)
    if (course.pagamento_partner === "1" && course.pagamento_self === "0") {
      return (
        <div className='mt-2 small'>
          <span className='d-block'>
            <i className="bi bi-ticket-perforated-fill text-primary me-1"></i>
            Pagamento: <strong>Tramite Voucher</strong>
          </span>
          <span className='d-block text-muted'>
            Il costo è gestito direttamente con la segreteria.
          </span>
        </div>
      );
    }
    
    // CASO 2: Pagamento con CARTA (a carico del Partner)
    if (course.pagamento_partner === "1" && course.pagamento_self === "1") {
      // Lo sconto qui è il margine totale del partner
      const prezzoFinalePartner = prezzoOriginale - margineMassimo;
      return (
        <div className='mt-2 small'>
          <span className='d-block'>
            <i className="bi bi-credit-card-fill text-info me-1"></i>
            Pagamento: <strong>A proprio carico (Carta)</strong>
          </span>
          <span className='d-block'>
            <i className="bi bi-tag-fill me-1"></i>
            Tuo sconto agenzia applicato: <strong>{margineMassimo.toFixed(2)} €</strong>
          </span>
          <span className='d-block'>
            <i className="bi bi-currency-euro me-1"></i>
            Costo finale per te: <del className="text-muted me-1">{prezzoOriginale.toFixed(2)}€</del><strong>{prezzoFinalePartner.toFixed(2)} €</strong>
          </span>
        </div>
      );
    }
    
    // CASO 3: Pagamento a carico del CORSISTA (con o senza sconto)
    if (course.pagamento_partner === "0") {
      const provvigione = margineMassimo - scontoApplicato;
      const prezzoFinaleCorsista = prezzoOriginale - scontoApplicato;

      return (
        <div className='mt-2 small'>
          <span className='d-block'>
            <i className="bi bi-person-fill me-1"></i>
            Pagamento: <strong>A carico del corsista</strong>
          </span>
          <span className='d-block'>
            <i className="bi bi-tag-fill text-danger me-1"></i>
            Sconto al corsista: <strong>{scontoApplicato.toFixed(2)} €</strong>
          </span>
          <span className='d-block text-success'>
              <i className="bi bi-graph-up me-1"></i>
              Tua provvigione: <strong>{provvigione.toFixed(2)} €</strong>
          </span>
          <span className='d-block'>
            <i className="bi bi-currency-euro me-1"></i>
            Prezzo per il corsista: <del className="text-muted me-1">{prezzoOriginale.toFixed(2)}€</del><strong>{prezzoFinaleCorsista.toFixed(2)} €</strong>
          </span>
        </div>
      );
    }

    return null;
  };
  
  return (
    <div className={`card shadow my-3 horizontalCourseCard py-2`}>
      <div className='d-flex justify-content-between'>
        <div className='d-flex gap-2'>
            <div className='align-self-center'>
                <img className='card-img' src={imgSrc} style={{height: '110px', width: '120px'}} alt='immagine corso' />
            </div>
            <div className='align-self-center card-content fs-6'>
              <span className='d-block fw-bold'>{course?.corso?.denominazione}</span>
              {renderPaymentDetails()}
            </div>
        </div>
        {isCreateUserView && (
          <div className='align-self-center'>
            <i role='button' onClick={() => onRemoveCourse(course.id_classe)} className="bi bi-trash-fill me-4 text-danger fs-3"></i>
          </div>
        )}
      </div>
    </div>
  );
}

export default HorizontalCourseCard;